import React from "react";
import { logClientError } from "@/lib/errorLog";

// Catches render/runtime errors so the app shows a readable message instead of a
// blank white screen, and reports the error for remote debugging.
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        logClientError("react_error_boundary", error?.message || String(error), error?.stack, (info?.componentStack || "").slice(0, 1500));
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#0b1220", color: "#e5e7eb", fontFamily: "system-ui, sans-serif" }} data-testid="error-boundary">
                    <div style={{ maxWidth: 420, textAlign: "center" }}>
                        <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
                        <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Ocurrió un problema</h1>
                        <p style={{ fontSize: 13, color: "#9ca3af", marginBottom: 16 }}>
                            La app encontró un error inesperado. Tus datos guardados no se perdieron.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{ background: "#dc2626", color: "white", border: "none", borderRadius: 10, padding: "10px 20px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}
                            data-testid="error-boundary-reload"
                        >
                            Recargar
                        </button>
                        <pre style={{ marginTop: 16, textAlign: "left", fontSize: 10, color: "#6b7280", whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: 160, overflow: "auto" }}>
                            {String(this.state.error?.message || this.state.error)}
                        </pre>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
